import React, { Component } from "react";
import { object } from "prop-types";
import { INPUT_TYPES } from "utils/CommonConstants";
import { RESOLUTIONS as BREAKPOINTS } from "services/config";
import BloxButton from "sub_components/Common/BloxButton";
import TextInput from "sub_components/Common/BloxTextInput";
import Modal from "sub_components/Common/PortalModalNew";
import IssueDescription from "./Edit/IssueDescriptionEdit";
import EditDetails from "./Edit/EditDetails";
import LocationSelection from "./LocationSelection";
import ProductSelection from "./ProductSelection";
import BillingSelection from "./BillingIssueSelection";
import EditSectionSmall from "./Edit/EditSectionSmall";
import ContactSelectionEdit from "./Edit/ContactSelectionEdit";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;
const LowPrioritySelected = `${CDN_URL}support/ticketing/low-priority-selected-lg.svg`;
const MediumPrioritySelected = `${CDN_URL}support/ticketing/medium-priority-selected-lg.svg`;
const HighPrioritySelected = `${CDN_URL}support/ticketing/high-priority-selected-lg.svg`;
const MAX_TEXT_AREA_HEIGHT = {
  [BREAKPOINTS.LOW]: 104,
  [BREAKPOINTS.MED]: 180,
  [BREAKPOINTS.HIGH]: 272,
};
class ReviewPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      section: null,
      submitClicked: false,
    };
  }
  getImage = (priority) => {
    if (priority === "low") {
      return LowPrioritySelected;
    } else if (priority === "high") {
      return HighPrioritySelected;
    } else {
      return MediumPrioritySelected;
    }
  };
  edit = (section) => {
    this.setState({ section });
  };

  closeEditModal = () => {
    this.setState({ section: null });
  };
  submitTicket = () => {
    const { data, submitTicket } = this.props;

    this.setState({ submitClicked: true });
    setTimeout(submitTicket(data), 2000);
  };
  render() {
    const {
      data: { priority, product, type, issue },
      breakpoint,
      data,
      updateData,
      services,
      invoices,
      auth_status,
      closeModal,
    } = this.props;

    const { section, submitClicked } = this.state;

    return (
      <div className="ticket-review-wrapper">
        <div className="ticket-description-wrapper">
          <div className="issue-description-section">
            <div className={`priority ${priority}`}>
              <div className="icon">
                <img src={this.getImage(priority)} />
              </div>
              <div className="priority-level">
                <div className="text buttons10">{`${
                  priority ? priority : "Medium"
                } PRIORITY`}</div>
              </div>
            </div>

            <TextInput
              placeholder="Please be as descriptive as possible."
              type={INPUT_TYPES.TEXTAREA}
              label="ISSUE Description"
              name="description"
              value={issue.description}
              onChange={this.onChange}
              active={true}
              setDefaultValueAsPlaceholder
              maxTextAreaHeight={MAX_TEXT_AREA_HEIGHT[breakpoint]}
              disabled={true}
              editOnClick={this.edit}
            />
          </div>
        </div>
        <div className="ticket-details-wrapper">
          <div className="contact-wrapper">
            <EditSectionSmall
              data={data}
              type="contact"
              title="CONTACT Details"
              edit={this.edit}
            />
          </div>
          <div className="attachments-wrapper">
            <EditSectionSmall
              data={data}
              type="issue"
              title="Attachments"
              edit={this.edit}
              updateData={updateData}
              auth_status={auth_status}
            />
          </div>
        </div>
        {type !== "billing" && (
          <div className="ticket-location-wrapper">
            <EditDetails title={"product"} data={data} edit={this.edit} />
            {product !== "Portal" && (
              <EditDetails title={"location"} data={data} edit={this.edit} />
            )}
          </div>
        )}
        {type === "billing" && (
          <div className="ticket-location-wrapper">
            <EditDetails title={"ISSUE Type"} data={data} edit={this.edit} />
          </div>
        )}
        {section && (
          <Modal>
            <div className="edit-section-modal-wrapper">
              <div className="edit-section">
                <div onClick={this.closeEditModal} className="close-icon">
                  <img src={CloseIcon} />
                </div>
                {section === "textarea" && (
                  <IssueDescription
                    data={data}
                    updateData={updateData}
                    breakpoint={breakpoint}
                  />
                )}
                {section === "contact" && (
                  <ContactSelectionEdit
                    phase="edit"
                    data={data}
                    updateData={updateData}
                    closeEditModal={this.closeEditModal}
                    auth_status={auth_status}
                  />
                )}
                {section === "issue" && (
                  //Upload section ?
                  <div>UPLOAD SECTION</div>
                )}
                {section === "location" && (
                  <LocationSelection
                    data={data}
                    updateData={updateData}
                    breakpoint={breakpoint}
                    services={services}
                    phase={"edit"}
                    closeEditModal={this.closeEditModal}
                  />
                )}
                {section === "product" && (
                  <ProductSelection
                    data={data}
                    updateData={updateData}
                    breakpoint={breakpoint}
                    services={services}
                    phase={"edit"}
                    closeEditModal={this.closeEditModal}
                  />
                )}
                {section === "billing" && (
                  <BillingSelection
                    data={data}
                    updateData={updateData}
                    phase={"edit"}
                    closeEditModal={this.closeEditModal}
                    invoices={invoices}
                  />
                )}
              </div>
            </div>
          </Modal>
        )}
        <div className="buttons-wrapper">
          <div className="cancel-button">
            <BloxButton
              title="CANCEL"
              enabled={true}
              customClass="blox-button-swipe"
              onClick={closeModal}
              id="cancel-button-swipe"
              cypressId="issue-request-cancel"
            />
          </div>
          <div className="submit-button">
            <BloxButton
              title="SUBMIT"
              cypressId="issue-request-submit"
              enabled={!submitClicked}
              customClass={
                submitClicked ? "blox-button-swipe active" : "blox-button-swipe"
              }
              onClick={this.submitTicket}
            />
          </div>
        </div>
      </div>
    );
  }
}

ReviewPage.propTypes = {
  data: object,
};

ReviewPage.defaultProps = {
  data: {
    location: "birmingham",
    priority: "medium",
    product: "Portal",
    type: "outage",
    issue: { description: "", attachments: [] },
  },
};

export default ReviewPage;
